interface IconProps {
  className?: string;
  size?: number;
}

export const EchoLogo = ({ className, size = 40 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="20" cy="20" r="20" fill="var(--preview-brand)" />
    <path
      d="M19.789 6.666C27.269 6.666 33.334 12.636 33.334 20s-6.065 13.334-13.545 13.334V22.644c-1.138 3.814-4.669 6.595-8.853 6.595v-7.474c-.693 1.675-2.343 2.855-4.27 2.855v-9.239c1.927 0 3.577 1.178 4.27 2.853v-7.473c4.184 0 7.715 2.781 8.853 6.595V6.666Z"
      fill="#fff"
    />
  </svg>
);

export const BackIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <circle cx="14" cy="14" r="14" fill="#f5f5f6" />
    <path
      d="m15.74 9.74-4.55 4.171 4.55 4.171"
      stroke="#02071d"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SendIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <rect width="28" height="28" rx="14" fill="var(--preview-brand)" />
    <path
      d="M9.51 9.01a.656.656 0 0 0-.709.894l1.166 2.892a.875.875 0 0 0 .811.548h3.441a.656.656 0 1 1 0 1.312h-3.44a.875.875 0 0 0-.812.548L8.8 18.096a.656.656 0 0 0 .71.894c3.82-.594 7.313-2.176 10.21-4.476a.656.656 0 0 0 0-1.028C16.822 11.186 13.33 9.604 9.51 9.01Z"
      fill="#fff"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="m2.25 2.25 7.5 7.5m-7.5 0 7.5-7.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
    />
  </svg>
);

export const MessageTailIcon = () => (
  <svg width="20" height="12" viewBox="0 0 20 12" aria-hidden="true">
    <path
      d="M1 9.962C9.924 10.968 16.718 8.075 19 6.503l-.254-4.717C16.296 2.101 10.989 2.384 9.366 1 9.62 6.66 2.775 9.49 1 9.962Z"
      fill="currentColor"
    />
    <path
      d="m19 6.503.229.332.186-.128-.013-.226-.402.022ZM1 9.962l-.103-.39.058.79L1 9.962ZM9.366 1l.262-.307-.706-.601.042.926L9.366 1Zm9.38.786.403-.021-.023-.434-.43.055.05.4Zm.025 4.385c-2.204 1.519-8.901 4.385-17.726 3.39l-.09.801c9.023 1.018 15.914-1.902 18.274-3.527l-.458-.664ZM1.104 10.35c.93-.247 3.135-1.093 5.087-2.606 1.95-1.513 3.713-3.747 3.578-6.763l-.805.036c.118 2.644-1.416 4.655-3.267 6.09-1.852 1.436-3.955 2.24-4.8 2.465l.207.778ZM9.105 1.307c.482.411 1.198.67 1.983.838.795.17 1.713.256 2.644.288 1.863.063 3.824-.088 5.066-.247l-.103-.8c-1.209.155-3.126.303-4.935.241-.905-.031-1.771-.114-2.504-.27-.743-.16-1.3-.383-1.628-.664l-.523.614Zm9.239.5.254 4.718.804-.044-.253-4.716-.805.043Z"
      fill="currentColor"
    />
  </svg>
);
